import React from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { api as coursesApi } from "../../../../../api/courses";

const AddCategory = ({ handleModal, refetch, categoryToEdit }) => {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      name: categoryToEdit?.name || "",
      description: categoryToEdit?.description || "",
    },
  });

  const createMutation = useMutation(coursesApi.createCategory);
  const updateMutation = useMutation((payload) =>
    coursesApi.updateCategory(payload, categoryToEdit?.id)
  );

  const handleCategory = async (payload) => {
    try {
      toast.loading("Processing...");
      let data;
      if (categoryToEdit) {
        data = await updateMutation.mutateAsync(payload);
      } else {
        data = await createMutation.mutateAsync(payload);
      }
      toast.remove();
      toast.success(data?.message || "Category saved successfully");
      setTimeout(() => {
        handleModal();
        refetch();
        reset();
      }, 1000);
    } catch (error) {
      toast.remove();
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit(handleCategory)}>
        <div className="w-full">
          <div className="flex-1 flex mb-7 items-start flex-col justify-center gap-1">
            <p className="text-sm">Category Name</p>
            <input
              className="w-full flex-1 border border-slate-300 block px-4 py-2 rounded-md outline-none bg-slate-100 duration-200 focus:ring-0 focus:px-5 focus:border-customBlue focus:bg-white"
              type="text"
              placeholder="Enter category name"
              {...register("name", {
                required: true,
              })}
            />
          </div>
          <div className="flex-1 flex items-start flex-col justify-center gap-1">
            <p className="text-sm">Description</p>
            <textarea
              className="w-full flex-1 border border-slate-300 block px-4 py-2 rounded-md outline-none bg-slate-100 duration-200 focus:ring-0 focus:px-5 focus:border-customBlue focus:bg-white"
              rows={5}
              placeholder="Enter category description"
              {...register("description", {
                required: true,
              })}
            />
          </div>
        </div>
        <div className="w-full flex items-center justify-end">
          <input
            type="submit"
            value={categoryToEdit ? "Update Category" : "Save Category"}
            className="mt-5 text-sm w-full md:w-auto px-8 py-2 border border-primary-blue cursor-pointer bg-primary-blue text-white rounded duration-100"
          />
        </div>
      </form>
    </div>
  );
};

export default AddCategory;
